import { useState, useRef, useEffect } from "react";

const TOTAL = 6;

function randomTargets() {
  return Array.from({ length: TOTAL }, (_, i) => ({
    id: i,
    top: 8 + Math.random() * 78,
    left: 6 + Math.random() * 82,
  }));
}

export default function TapTargets({ onComplete }) {
  const [targets, setTargets] = useState([]);
  const [hits, setHits] = useState(0);
  const misses = useRef(0);
  const start = useRef(Date.now());

  useEffect(() => {
    setTargets(randomTargets());
  }, []);

  const finish = (finalHits) => {
    const duration = Math.round((Date.now() - start.current) / 1000);
    const totalTaps = finalHits + misses.current;
    const accuracy = totalTaps ? Math.round((finalHits / totalTaps) * 100) : 100;
    setTimeout(() => onComplete({ score: accuracy, accuracy, duration }), 500);
  };

  const hitTarget = (id, e) => {
    e.stopPropagation();
    setTargets((t) => t.filter((x) => x.id !== id));
    const nh = hits + 1;
    setHits(nh);
    if (nh === TOTAL) finish(nh);
  };

  const missTap = () => {
    misses.current += 1;
  };

  return (
    <div className="w-full max-w-3xl mx-auto text-center" data-testid="taptargets-game">
      <p className="text-2xl font-patient font-bold text-gray-700 mb-6">
        Touchez chaque rond vert ({hits}/{TOTAL})
      </p>
      <div
        onClick={missTap}
        data-testid="taptargets-area"
        className="relative w-full h-[26rem] rounded-3xl bg-white border-4 border-emerald-700/20 overflow-hidden"
      >
        {targets.map((t) => (
          <button
            key={t.id}
            data-testid={`tap-target-${t.id}`}
            onClick={(e) => hitTarget(t.id, e)}
            style={{ top: `${t.top}%`, left: `${t.left}%` }}
            className="absolute w-20 h-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-600 border-4 border-white shadow-lg soft-pulse active:scale-90 transition-transform duration-150"
          />
        ))}
      </div>
    </div>
  );
}
